module.exports = __webpack_public_path__ + "static/NW_Lucas_Bild_Lands_34-998cf40ac7c40aceb93eb7699d93bd06.jpg";